import React from "react";
import ContrastForegroundUtility from "../../utils/ContrastForegroundUtility";

const EndUserDownloadLink = ({
  href,
  colorTheme
}: {
  href: string;
  colorTheme: string;
}) => {
  return (
    <a
      href={href}
      className="btn-add-cart geo-btn--caps"
      style={{
        background: ContrastForegroundUtility.lbFgColor(colorTheme),
        borderColor: ContrastForegroundUtility.lbFgColor(colorTheme),
        color: "white"
      }}
      download
    >
      <span
        className="fa fa-download"
        style={{ color: "white", marginRight: 8 }}
      />
      <span>Download now</span>
    </a>
  );
};

export default EndUserDownloadLink;
